import skinTones from 'emojis/skin_tones.json';

// Same order as UserPreference#emoji_skin_tone and as the fixture's variant lists.
const TONES = ['light', 'medium_light', 'medium', 'medium_dark', 'dark'];

let baseByVariant;

const baseByVariantMap = () => {
  if (!baseByVariant) {
    baseByVariant = new Map(
      Object.entries(skinTones.variants).flatMap(([base, variants]) =>
        variants.map((variant) => [variant, base]),
      ),
    );
  }

  return baseByVariant;
};

/**
 * The user's default skin tone, or `null` when the preference is unavailable:
 * the feature flag is off or the viewer is signed out.
 */
export const userSkinTone = () => window.gon?.emoji_skin_tone ?? null;

export const isSkinTonePreferenceEnabled = () => userSkinTone() !== null;

/**
 * The plain emoji a toned name belongs to. Names without a tone group,
 * including two-tone and unmapped names, return themselves.
 */
export const baseName = (name) => baseByVariantMap().get(name) ?? name;

export const variantsFor = (base) => skinTones.variants[base] ?? [];

/** The variant of `name`'s emoji in the user's default skin tone. */
export const preferredVariant = (name) => {
  const base = baseName(name);
  const variants = variantsFor(base);
  const toneIndex = TONES.indexOf(userSkinTone());

  return toneIndex === -1 || !variants.length ? base : variants[toneIndex];
};
